/**
 * Reduces a `login_redirect` value to a path on the app's own origin, so that
 * neither a crafted link nor a stale value can send the user elsewhere after
 * logging in. Falls back to the start page.
 */
export const toSafeLoginRedirect = (
    value: string | null | undefined,
    origin: string = window.location.origin,
): string => {
    if (!value) {
        return '/';
    }

    let url: URL;
    try {
        url = new URL(value, origin);
    } catch {
        return '/';
    }

    if (
        url.origin !== origin ||
        url.pathname.startsWith('//') ||
        url.pathname.startsWith('/login')
    ) {
        return '/';
    }

    return `${url.pathname}${url.search}${url.hash}`;
};

/**
 * Whether a redirect returned by the logout endpoint leaves the app, e.g. to
 * the end session endpoint of an OIDC provider. Redirects back to our own
 * login page are ignored in favour of one that keeps the `login_redirect`.
 */
export const isExternalRedirect = (
    redirect: string,
    origin: string = window.location.origin,
): boolean => {
    try {
        return new URL(redirect, origin).origin !== origin;
    } catch {
        return false;
    }
};
